import { TOKEN_KEY, REFRESH_EARLY_TIME, SERVICE_KEY } from '../../constant';
import { getDateNow, getTokenInfo, refreshTokenInfo } from '../../services/business-service/auth';
import { getTicket, toSSO } from "../../utils/location";
import { getCookie } from "../../utils/cookieUtils";
import { InitState } from '../../constant';

/**
 * @param {*} params { service: string; ticket: string }
 * @returns 
 */
const getToken = async (params) => {
  const { rs } = await getTokenInfo(params);
  if (rs) {
    // updateToken(rs);
    localStorage.setItem(TOKEN_KEY, JSON.stringify(rs));
    return rs;
  }
  return null;
}

const refreshToken = async (rt) => {
  const { rs } = await refreshTokenInfo({ rt });
  if (rs ) {
    // updateToken(rs);
    localStorage.setItem(TOKEN_KEY, JSON.stringify(rs));
    return rs
  }
  return null;
}
;

const initToken = async () => {
  const rs = JSON.parse(localStorage.getItem(TOKEN_KEY) || 'null');

  if (rs) {
    // 关闭浏览器后，重新进入Uai需要重新登录 cookie关闭浏览器后会清空
    const cookieJwt = getCookie('jwt');
    if(!cookieJwt){
      // 没有cookie 需要重新登录
      toSSO('login');
      return null;
    }

    // id token 有效
    if (getDateNow() < rs.jwtExpire * 1000 - REFRESH_EARLY_TIME) {
      // updateToken(rs);
      return rs;
    }

    // refresh token 有效
    if (getDateNow() < rs.rtExpire * 1000) {
      const result = await refreshToken(rs.rt);
      if (result) {
        return result;
      }
    }
  }

  // 获取 ticket
  const ticket = getTicket();
  if (!ticket) {
    // dispatch(ssoLogin());
    if (window.location.search.indexOf('logout') !== -1) {
      window.history.replaceState(null, '', `${window.location.protocol}//${window.location.host}`);
    }
    return null;
  }

  // 获取 service
  const service = localStorage.getItem(SERVICE_KEY);
  // 移除 url 上的 ticket
  window.history.replaceState(null, '', service);

  const tokenInfo = await getToken({ service, ticket });
  return tokenInfo;
};

const init = async () => {
  const rs = await initToken();
  InitState.tokenInfo = rs;
  return rs;
  // if (rs) {
  //   const result = await getUserInfo();console.log(result, 111111)
  // }
};

export { init };